module.exports = __webpack_public_path__ + "static/media/VPM_mobile_3.850222d8.jpg";